import React, { Component } from 'react';
import * as firebase from 'firebase';
import {Link} from 'react-router-dom';
import ReactLoading from 'react-loading';
import MetaTags from 'react-meta-tags';

import '../css/medicalTeam.css';

export default class AuthorityTag extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOfPositions: [],
      listOfMedicalTeams: [],
      author: '草學藥事',
      loading: true,
      blogTag: '',
      otherTag1: false,
      otherTag2: false
    }
  }


  componentDidMount() {
    window.scrollTo(0,0);
    let blogTag = this.props.match.params.blogTag;
    const postListRef = firebase.database().ref('MedicalTeamPosts/').orderByChild('blogTag').equalTo(blogTag);
    setTimeout(() => this.setState({ loading: false }), 2000);


    postListRef.on('child_added', snap => {
        const previousList = this.state.listOfPositions;
        previousList.push({
          createDate: snap.val().createDate,
          createTime: snap.val().createTime,
          blogName: snap.val().blogName,
          blogTag: snap.val().blogTag,
          secondTag: snap.val().secondTag,
          otherTag1: snap.val().otherTag1,
          otherTag2: snap.val().otherTag2,
          listPhoto: snap.val().listPhoto ? snap.val().listPhoto : 'https://firebasestorage.googleapis.com/v0/b/herbal-cure.appspot.com/o/Authority%2Fee05d537-ddf4-47a2-b1a2-21a6063a4299.gif?alt=media&token=824bf77c-bbae-408e-af80-7e4b8d5d1ea7',
          id: snap.val().id
        })
        this.setState({
            listOfPositions: previousList.reverse()
        })
    })

    const listRef = firebase.database().ref('medicalTeam/');
    listRef.on('value', snap => {
      snap.forEach((child) => {
        const previousList = this.state.listOfMedicalTeams;
        previousList.push({
           LicensePhoto: child.val().LicensePhoto,
           MedicalExpertise: child.val().MedicalExpertise,
           OfficeUnit: child.val().OfficeUnit,
           ProfessionalCertification: child.val().ProfessionalCertification,
           mba: child.val().mba,
           userId: child.val().userId,
           name: child.val().name,
           Authority: child.val().Authority
        })
        this.setState({
            listOfMedicalTeams: previousList.reverse()
        })
      })
    })

  }


  render() {
    const { loading } = this.state;

    if(loading) {
      return <ReactLoading type={"bubbles"} color={"#333"} style={Jeyu.loading} />
    }
    const listOfMedicalTeams = this.state.listOfMedicalTeams.map(position =>
        <article key={position.userId} className="medicalTeamBoxList"  >
         <Link to={"/MedicalTeams/" + position.userId} target="_blank">
          <div style={{height: 100, textAlign: 'center'}} >
           <img src={position.LicensePhoto} alt=""  style={{height:'100%', display: 'block', margin: '0 auto', textAlign: 'center'}} />
          </div>
          <h3>{position.name} {position.Authority}</h3>
         </Link>
        </article>
     )
    const listOfPositions = this.state.listOfPositions.map(position =>
         <article key={position.id} className="postBox">
           <sub><span>{position.createDate}</span><span>{position.createTime}</span></sub>
           <sub>發文者: {this.state.author}</sub>
           <Link to={"/AuthorityBlogs/" + position.id} target="_blank">
            <h1>{ position.blogName }</h1>
            <div className="postListBox">
             <img src={position.listPhoto} alt={position.blogTag} />
            </div>
           </Link>
           <sub className="postListTagsBox" >
           <Link to={"/AuthorityTag/" + position.blogTag} target="_blank">{ position.blogTag }</Link>
           <Link to={"/AuthorityTags/" + position.secondTag} target="_blank">{ position.secondTag }</Link>
           <Link to={"/AuthorityTagsa/" + position.otherTag1} style={{display: position.otherTag1 ? 'inline-block' : 'none'}} target="_blank">{ position.otherTag1 }</Link>
           <Link to={"/AuthorityTagsb/" + position.otherTag2} style={{display: position.otherTag2 ? 'inline-block' : 'none'}} target="_blank">{ position.otherTag2 }</Link>
           </sub>
         </article>
    )

    return(
       <div className="container-fluid">
        <MetaTags>
          <title>草學藥事 || 健康達人專欄</title>
          <meta id="og-title" property="og:title" content="健康達人專欄" />
        </MetaTags>
        <div className="row haspcMinH">
         <div className="MedicalTeamBanner">
          <h1 style={{color: '#fff'}} >健康達人專欄</h1>
         </div>
         <h2 style={{fontSize: 20, color: '#333', textAlign: 'center'}} >健康達人</h2>
                 <div className="medicalTeamBox">{listOfMedicalTeams}</div>
         <div className="container">
          <div className="row">
           <section className="masonry" style={{borderTop: '2px dotted #dcdcdd', paddingTop: 35}}>
            {listOfPositions}
           </section>
          </div>
         </div>
        </div>
       </div>
    )
  }
}

const Jeyu = {
  loading: {
    margin: '20% auto',
    width: 77,
    height: '100vh'
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center'
  }
}



// WEBPACK FOOTER //
// ./src/post/AuthorityTag.js